export function huddleVideoIdFromPerson(person) {
  const ref = person?.otherMeetingRef;
  const id = Number(ref?.videoRoomId || ref?.video_room_id);
  return Number.isFinite(id) && id > 0 ? id : 0;
}

/**
 * Colegas no piso em outra chamada que ainda não aparecem nas salas internas.
 * Mesmo recorte da home: huddles ficam nos cards de sala; o resto em "em reunião".
 */
export function peopleInOtherCalls({ presence = [], huddles = [], myUserId } = {}) {
  const myId = Number(myUserId) || 0;
  const huddleIds = new Set(
    (huddles || []).map((h) => Number(h.videoRoomId || h.id)).filter((id) => id > 0)
  );
  const huddleUserIds = new Set(
    (huddles || []).flatMap((h) => (h.participants || []).map((p) => Number(p.userId)))
  );
  return (presence || []).filter((p) => {
    const uid = Number(p.userId);
    if (!uid || (myId && uid === myId)) return false;
    if (p.status !== "in_other_meeting") return false;
    const hid = huddleVideoIdFromPerson(p);
    if (hid && huddleIds.has(hid)) return false;
    if (huddleUserIds.has(uid)) return false;
    return true;
  });
}
